<template>
  <el-card style="height: 99%;" class="box-card" @click="adminshow">
    <div slot="header" class="clearfix">
      <!-- 标题 -->
      <span style="font-size: 24px" class="font-sz24">{{ $t('企业管理.企业管理') }}</span>
    </div>
    <el-row style="height:100%" class="ovf-hid">
      <el-col :span="11" :offset="1">
        <el-upload :show-file-list="false" class="avatar-uploader border-none" :action="actionUrl3" :data="updataLogo"
          :headers="importHeaders" :on-success="handleAvatarSuccess2" :before-upload="beforeAvatarUpload"
          style="border: none">
          <img v-if="imageUrl" :src="imageUrl" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
        <el-form :model="Companyinfo" label-width="150px" ref="Companyinfo" :rules="rules">
          <el-form-item :label="$t('企业管理.单位简称')" prop="comp18">
            <el-input v-model="Companyinfo.comp18" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item :label="$t('企业管理.单位名称')" prop="comp02">
            <el-input v-model="Companyinfo.comp02" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item :label="$t('企业管理.企业编码')" prop="comp03">
            <el-input v-model="Companyinfo.comp03" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item :label="$t('企业管理.单位类别')" prop="comp05">
            <el-input v-model="Companyinfo.comp05" auto-complete="off"></el-input>
            <!-- <el-select filterable v-model="Companyinfo.comp05" >
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select> -->
          </el-form-item>

          <el-form-item :label="$t('企业管理.地址')" prop="comp06">
            <el-input v-model="Companyinfo.comp06" auto-complete="off"></el-input>
            <!-- <div class="container">
              <div class="dome-main">
                <div class="city-picker-selector" id="city-picker-selector1"></div>
              </div>
            </div>
            <el-input v-model="detialAdree" type="textarea"></el-input> -->
          </el-form-item>
        </el-form>


      </el-col>
      <el-col :span="11" :offset="1">
        <el-form :model="Companyinfo" label-width="150px" ref="Companyinfo2" :rules="rules">
          <el-form-item :label="$t('企业管理.邮箱')" prop="comp04">
            <el-input v-model="Companyinfo.comp04" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item :label="$t('企业管理.电话')" prop="comp07">
            <el-input v-model="Companyinfo.comp07" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item :label="$t('企业管理.网址')" prop="comp08">
            <el-input v-model="Companyinfo.comp08" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item :label="$t('企业管理.项目容量')" prop="comp12">
            <el-input v-model="Companyinfo.comp12" auto-complete="off" disabled></el-input>
          </el-form-item>
          <el-form-item :label="$t('企业管理.空间容量')" prop="comp11">
            <el-input v-model="Companyinfo.comp11" auto-complete="off" disabled></el-input>
          </el-form-item>
          <el-form-item :label="$t('企业管理.成员容量')" prop="comp09">
            <el-input v-model="Companyinfo.comp09" auto-complete="off" disabled></el-input>
          </el-form-item>
          <el-form-item :label="$t('企业管理.授权期限')" prop="comp14">
            <el-date-picker v-model="Companyinfo.comp14" type="datetimerange" range-separator="-"
              start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss" disabled></el-date-picker>
          </el-form-item>
          <!-- <el-form-item :label="$t('企业管理.高级授权')" prop="comp13">
            <el-checkbox-group v-model="permissionsList" disabled>
              <el-checkbox :label="item.value" v-for="item in permissionsList2" :key="item.value">{{ item.name
              }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item> -->
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4" :offset="11">
        <el-button type="primary" @click="EditCompany('Companyinfo', 'Companyinfo2')">{{ $t('common.确定') }}</el-button>
        <el-button type="danger">{{ $t('common.取消') }}</el-button>
      </el-col>
    </el-row>
  </el-card>
</template>

<script>
import { GetCompanyinfo, EditCompany } from "@/setAxios";
export default {
  name: "enterpriseManagement",
  data() {
    return {
      options: [
        { value: "国防机构", label: "国防机构" },
        { value: "政府机关", label: "政府机关" },
        { value: "事业单位", label: "事业单位" },
        { value: "企业", label: "企业" },
        { value: "个人", label: "个人" },
        { value: "社会团体", label: "社会团体" },
        { value: "民办非企业单位", label: "民办非企业单位" },
        { value: "世界五百强", label: "世界五百强" },
        { value: "央属国企", label: "央属国企" },
        { value: "地方国企", label: "地方国企" },
        { value: "群众性团体组织", label: "群众性团体组织" },
        { value: "司法鉴定机构", label: "司法鉴定机构" },
        { value: "宗教团体", label: "宗教团体" },
        { value: "境外机构", label: "境外机构" },
        { value: "医疗机构", label: "医疗机构" },
        { value: "公认机构", label: "公认机构" },
      ],
      detialAdree: "",
      actionUrl3: this.$store.state.baseUrl + "/api/UploadLogo",
      importHeaders: { token: localStorage.getItem("token") },
      permissionsList: [],
      permissionsList2: [
        { name: "上传模型", value: "scmx" },
        { name: "转换模型", value: "zhmx" },
        { name: "图纸模块", value: "tzmk" },
      ],
      imageUrl: "",
      dateOfBirth: "",
      Companyinfo: {},
      updataLogo: {
        qid: localStorage.getItem("pid"),
      },
      rules: {
        comp02: [
          { required: true, message: "请输入单位名称", trigger: "blur" },
        ],
        comp04: [{ required: true, message: "请输入邮箱", trigger: "blur" }],
        comp05: [
          { required: true, message: "请输入单位类别", trigger: "blur" },
        ],
        comp06: [{ required: true, message: "请输入地址", trigger: "blur" }],
        comp07: [
          { required: true, message: "请输入您的电话", trigger: "blur" },
        ],
        comp08: [
          { required: true, message: "请输入单位网址", trigger: "blur" },
        ],
        comp09: [
          { required: true, message: "请输入用户数量", trigger: "blur" },
        ],
        comp11: [
          { required: true, message: "请输入可用空间", trigger: "blur" },
        ],
        comp12: [{ required: true, message: "请输入项目数", trigger: "blur" }],
        comp13: [
          { required: true, message: "请选择权限列表", trigger: "blur" },
        ],
        comp14: [
          { required: true, message: "请选择授权有效期", trigger: "blur" },
        ],
        comp18: [
          { required: true, message: "请填写公司简称", trigger: "blur" },
          // { min: 1, max: 4, message: "长度在 1 到 4 个字符", trigger: "blur" }
        ],
      },
    };
  },
  created() {
    this.GetCompanyinfo2();
    this.$store.state.btnStyle = ["btns", "btns", "btns", "btnss"];
  },
  methods: {
    first() {
      var that = this;
      // 模拟城市-无联动/无搜索
      // var selector1 = $("#city-picker-selector1").cityPicker({
      //   dataJson: cityData,
      //   renderMode: true,
      //   search: true,
      //   storage: true,
      //   autoSelected: true,
      //   shorthand: false,
      //   code: "cityCode",
      //   level: 2,
      //   onChoiceEnd: function () {
      //     that.Companyinfo.comp06 = selector1.getCityNameVal();
      //   },
      // });
      // if (that.Companyinfo.comp06 != null) {
      //   selector1.setCityVal(that.Companyinfo.comp06.split("/")[0]);
      //   that.detialAdree = that.Companyinfo.comp06.split("/")[1];
      //   that.Companyinfo.comp06 = that.Companyinfo.comp06.split("/")[0];
      // }
    },
    getData() {
      this.GetCompanyinfo2();
    },
    beforeUpload(file) {
      this.imageUrl = URL.createObjectURL(file.raw);
      let fd = new FormData();
      fd.append("file", file);
      fd.append("Companyinfo", this.Companyinfo);
      var index = file.name.lastIndexOf(".");
      var suffix = file.name.substring(index + 1);
      const extension = suffix === "png";
      const extension2 = suffix === "jpg";
      const isLt500M = file.size / 1024 / 1024 < 10;
      //(suffix);
      if (!extension && !extension2) {
        this.$message({
          message: this.$t('common.处理失败'),
          type: "warning",
        });
        this.loading2 = false;
      }
      if (!isLt500M) {
        this.$message({
          message: this.$t('common.处理失败'),
          type: "warning",
        });
      }
      return extension || (extension2 && isLt500M);
    },
    // 修改企业信息
    EditCompany(form1, form2) {
      this.$refs[form1].validate((valid) => {
        if (valid) {
          this.$refs[form2].validate((valid) => {
            if (valid) {
              // this.Companyinfo.comp06 =
              //   this.Companyinfo.comp06 + "/" + this.detialAdree;
              this.Companyinfo.comp13 = this.permissionsList;
              let params = JSON.stringify(this.Companyinfo);
              EditCompany({ model: params }).then((res) => {
                if (res.Code == 1) {
                  this.$message({
                    type: "success",
                    message: this.$t('common.处理成功'),
                  });
                } else {
                  this.$message.error(this.$t('common.处理失败'))
                }
                this.getData();
              });
            }
          });
        }
      });
    },
    // 获取企业详细信息
    GetCompanyinfo2() {
      let params = {
        cid: localStorage.getItem("pid"),
      };
      GetCompanyinfo({ params }).then((res) => {
        this.Companyinfo = res.Data;
        this.imageUrl = this.$store.state.companyLogo =
          this.$store.state.baseUrl + res.Data.comp10;
        this.$store.state.shortName = this.Companyinfo.comp18;
        if (this.Companyinfo.comp13) {
          this.Companyinfo.comp13 = this.Companyinfo.comp13.split(",");
          this.permissionsList = this.Companyinfo.comp13;
        }
        this.Companyinfo.comp14 = this.Companyinfo.comp14.split(",");
        // this.first();
      });
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    // 关闭菜单栏显示
    adminshow() {
      this.$emit("update:showAdmin", true);
    },
    handleAvatarSuccess2(res, file) {
      if (res.Code == 1) {
        this.imageUrl = URL.createObjectURL(file.raw);
        this.$message({
          type: "success",
          message: this.$t('common.处理成功'),
        });
        this.addEnterprise1 = false;
        this.getData();
      } else {
        this.$message({
          type: "warning",
          message: this.$t('common.处理失败'),
        });
      }
    },
    beforeAvatarUpload(file) {
      let fd = new FormData();
      fd.append("file", file);
      fd.append("model", this.addqiye);
      var index = file.name.lastIndexOf(".");
      var suffix = file.name.substring(index + 1);
      const extension = suffix === "png" || suffix === "jpg" || suffix === "bmp" || suffix === "tif" || suffix === "webp" || suffix === "jpeg"
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!extension) {
        this.$message({
          message: this.$t('common.处理失败'),
          type: "warning",
        });
        this.loading2 = false;
      }
      if (!isLt10M) {
        this.$message({
          message: this.$t('common.处理失败'),
          type: "warning",
        });
      }
      return extension && isLt10M
    },
  },
};
</script>

<style lang="less" scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader {
  text-align: center;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  max-width: 656px;
  width: auto;
  height: 178px;
  display: block;
}

.avatar-uploader {
  border: 1px dashed #d9d9d9;
  margin-bottom: 20px;
  width: 664px;
  margin-left: 80px;
}

.dome-main {
  padding: 0px;
}

.container {
  margin: 0px;
}

// 新增
.font-sz24 {
  font-size: 24px;
}

.ovf-hid {
  // overflow: hidden;
}

.border-none {
  border: none;
}
</style>
